<!--
* @Name：采购订单付款计划
* @Author: 刘玉
* @Date: 2021-12-02 15:43:31
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-02 15:43:31
-->
<template>
  <div>
    <hi-card v-for="(item, index) in planList" :key="item.poCreatePayPlanId" :row-index="index + 1">
      <van-row>
        <span>付款阶段：</span>
        <span>{{ item.payStageDict | dictFilter(payStageOptions) }}</span>
      </van-row>
      <van-row>
        <span>付款计划类型：</span>
        <span>{{ item.payPlanTypeDict | dictFilter(pdSurceOptions) }}</span>
      </van-row>
      <van-row>
        <span>付款金额：</span>
        <span>{{ item.payAmount }}</span>
      </van-row>
      <van-row>
        <span>是付款比例%：</span>
        <span>{{ item.payRatio }}</span>
      </van-row>
      <van-row>
        <span>预计付款时间：</span>
        <span>{{ item.payDate }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
import { selectPlan } from '@/api/purchaseOrder'
import { selectModifyPlan } from '@/api/purchaseOrderModify'
export default {
  name: 'PaymentPlan',
  data() {
    return {
      // poCreateHeadId: this.$store.getters.businessKey,
      poCreateHeadId: this.$route.query.businessKey,
      planList: []
    }
  },
  computed: {
    payStageOptions() {
      return this.$store.getters.dicts.pay_stage
    },
    pdSurceOptions() {
      return this.$store.getters.dicts.pd_surce
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    async initData() {
      if (this.todoName === 'PomApproval') {
        const response = await selectModifyPlan(this.poCreateHeadId)
        this.planList = response.data
      } else if (this.todoName === 'PoApproval') {
        // const detailsResp = await selectPlan(this.$store.getters.businessKey)
        const detailsResp = await selectPlan(this.$route.query.businessKey)
        this.planList = detailsResp.data
      }
    }
  }
}
</script>
